<template>
  <div class="technician_center">
    <div class="technician_box">
      <div class="technician_info">
        <img class="fl" :src="tech.thumb?tech.thumb:tech.member_avatar" alt />
        <div class="technician_bottom fl">
          <p class="technician_name">{{tech.name}}</p>
          <p class="technician_xx">
            <van-rate
              v-model="technician_score"
              allow-half
              void-icon="star"
              void-color="white"
              size="15"
              :readonly="true"
            />
          </p>
        </div>
      </div>

      <div class="technician_order">
        <router-link :to="{ path: '/tech_order', query: { status: 99 }}" class="order_title">
          <span class="fl">我的订单</span>
          <div class="order_all fr flex">
            <span class>全部订单</span>
            <van-icon name="arrow" />
          </div>
        </router-link>

        <div style="padding:.25rem 0 .5rem;">
          <div class="van-hairline--top-bottom van-tabbar van-tabbar--fixed" style="z-index: 1;">
            <router-link :to="{ path: '/tech_order', query: { status: 0 }}" class="van-tabbar-item">
              <div class="van-tabbar-item__icon">
                <img src="/static/img/djd.png" />
                <div class="van-info" v-if="totaldaijiedan>0">{{totaldaijiedan}}</div>
              </div>
              <div class="van-tabbar-item__text">
                <span>待接单</span>
              </div>
            </router-link>

            <router-link :to="{ path: '/tech_order', query: { status: 1 }}" class="van-tabbar-item">
              <div class="van-tabbar-item__icon">
                <img src="/static/img/dfw.png" />
                <div class="van-info" v-if="totaldaifuwu>0">{{totaldaifuwu}}</div>
              </div>
              <div class="van-tabbar-item__text">
                <span>待服务</span>
              </div>
            </router-link>

            <router-link :to="{ path: '/tech_order', query: { status: 3 }}" class="van-tabbar-item">
              <div class="van-tabbar-item__icon">
                <img src="/static/img/fwz.png" />
                <div class="van-info" v-if="totalfuwuzhong>0">{{totalfuwuzhong}}</div>
              </div>
              <div class="van-tabbar-item__text">
                <span>服务中</span>
              </div>
            </router-link>

            <router-link :to="{ path: '/tech_order', query: { status: 2 }}" class="van-tabbar-item">
              <div class="van-tabbar-item__icon">
                <img src="/static/img/yjj.png" />
                <div class="van-info" v-if="totalyijujue>0">{{totalyijujue}}</div>
              </div>
              <div class="van-tabbar-item__text">
                <span>已拒绝</span>
              </div>
            </router-link>

            <router-link :to="{ path: '/tech_order', query: { status: 4 }}" class="van-tabbar-item">
              <div class="van-tabbar-item__icon">
                <img src="/static/img/ycl.png" />
                <div class="van-info" v-if="totalyiwanchen>0">{{totalyiwanchen}}</div>
              </div>
              <div class="van-tabbar-item__text">
                <span>已完成</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="technician_list">
      <a class="van-cell" href="javascript:void(0);" @click="scan">
        <i class="iconfont icon-iconfonterweima van-cell__left-icon"></i>
        <div class="van-cell__title">
          <span>扫码核销</span>
        </div>
        <div class="van-cell__value">
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </a>

      <router-link to="/tech_income" class="van-cell">
        <i class="iconfont icon-qianbao van-cell__left-icon"></i>
        <div class="van-cell__title">
          <span>我的收入</span>
        </div>
        <div class="van-cell__value flex_center">
          <span class="col_F5643D">￥{{tech.total_income}}</span>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </router-link>

      <router-link to="/tech_selectStore" class="van-cell">
        <i class="iconfont icon-dianpu1 van-cell__left-icon"></i>
        <div class="van-cell__title">
          <span>选择门店</span>
        </div>
        <div class="van-cell__value">
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </router-link>

      <div class="van-cell" @click="showPopup">
        <i class="iconfont icon-tianchongxing- van-cell__left-icon"></i>
        <div class="van-cell__title">
          <span>当前状态</span>
        </div>
        <div class="van-cell__value flex_center">
          <span
            :class="['technician_status',up_workstatus==0?'technicial_status_bg':'']"
          >{{up_workstatus==0?'休息':'工作'}}</span>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>

      <!-- <div class="van-cell">
        <i class="iconfont icon-tuijianren van-cell__left-icon"></i>
        <div class="van-cell__title">
          <span>推荐分享</span>
        </div>
        <div class="van-cell__value">
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>-->

      <router-link to="/tech_data" class="van-cell">
        <i class="iconfont icon-gerenziliao van-cell__left-icon"></i>
        <div class="van-cell__title">
          <span>我的资料</span>
        </div>
        <div class="van-cell__value">
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </router-link>
    </div>

    <van-popup v-model="work_show" :closeable="true" :round="true">
      <p class="wks_label">请选择当前状态</p>
      <div class="wks_icon" @click="update_workstatus_style(1)">
        <span :class="['iconfont','icon-gongzuoxinxi1',work_status==1?'work_status':'']"></span>
        <p>工作</p>
      </div>
      <div class="wks_icon" @click="update_workstatus_style(0)">
        <span :class="['iconfont','icon-xiuxi1',work_status==0?'work_status':'']"></span>
        <p>休息</p>
      </div>
      <div class="btn_box">
        <button @click="up_work" class="check_btn">确认</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "tech_center",
  components: {},
  data() {
    return {
      technician_score: 5,
      order_active: 0,
      quxiaodingdan1: "iconfont icon-quxiaodingdan1",
      jinhangzhong: "iconfont icon-jinhangzhong",
      erweima: "iconfont icon-erweima",
      yiwancheng1: "iconfont icon-yiwancheng1",
      work_status: 0,
      up_workstatus: 0,
      work_show: false,
      tech: [],
      tech_order: [],
      order_status: 99,
      totaldaijiedan: 0,
      totaldaifuwu: 0,
      totalyichuli: 0,
      totalyiwanchen: 0,
      totalyijujue: 0,
      totalfuwuzhong: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get_tech();
      this.get_tech_order();
    },
    get_tech() {
      this.axios({
        url: this.api.tech.get_tech,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tech = res.tech;
          this.up_workstatus = res.tech.status;
          this.work_status = res.tech.status;
          // that.technician_score = parseFloat(res.tech.score);
        }
      });
    },
    get_tech_order() {
      this.axios({
        url: this.api.order.get_tech_order,
        data: { order_status: this.order_status }
      }).then(res => {
        if (res.error === 0) {
          this.tech_order = res.tech_order;
          this.totalyiwanchen = res.totalyiwanchen;
          this.totaldaifuwu = res.totaldaifuwu;
          this.totaldaijiedan = res.totaldaijiedan;
          this.totalyijujue = res.totalyijujue;
          this.total = res.total;
          // that.technician_score = parseFloat(res.tech.score);
        }
      });
    },
    closePopup() {
      this.work_show = false;
    },
    showPopup() {
      this.work_show = true;
    },
    update_workstatus_style(status) {
      this.work_status = status;
    },
    up_work() {
      this.up_workstatus = this.work_status;
      this.axios({
        url: this.api.tech.change_workstatus,
        data: { workstatus: this.up_workstatus }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            type: "success",
            onClose: () => {
              this.get_tech();
              this.closePopup();
            }
          });
          // that.technician_score = parseFloat(res.tech.score);
        }
      });
    },
    scan() {
      //微信扫一扫
      this.wx.wxScan(res => {
        var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        this.axios({
          url: this.api.tech.tech_hexiao, //技师核销
          data: { verify_code: result }
        }).then(res => {
          if (res.error == 0) {
            this.$toast({
              message: "核销订单成功",
              duration: 1000,
              onClose: function() {
                //  this.get_order();
                location.reload();
              }
            });
          }
        });
      });
      return false;
    }
  }
};
</script>
<style scoped>
.icon-iconfonterweima {
  color: #45b9bc;
}
.technician_box {
  background-color: #45b9bc;
}
.technician_info {
  padding: 1rem 0.75rem;
  clear: both;
  overflow: hidden;
}
.technician_info img {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
}
.technician_bottom {
  padding-left: 0.3rem;
}
.technician_name {
  font-size: 0.75rem;
  color: white;
}
.van-cell__value {
  position: absolute;
  right: 0.75rem;
}
.technician_order {
  width: 90%;
  margin: 0 auto;
  background-color: white;
  border-radius: 2px 2px 0 0;
  box-shadow: 0px 0px 10px 1px rgba(11, 100, 104, 0.31);
}
.order_title {
  clear: both;
  overflow: hidden;
  font-size: 0.75rem;
  color: #4e4e4e;
  padding: 0.6rem 0.5rem;
  width: 100%;
}
.order_all {
  font-size: 0.6rem;
  color: #949595;
  padding-top: 0.1rem;
}
.van-tabbar--fixed {
  position: static;
}
.van-tabbar-item__icon img {
  width: 1.5rem;
  height: 1.5rem;
}
.van-info {
  border: 0;
}
.technician_list {
  margin-top: 1rem;
  font-size: 0.75rem;
}
.icon-qianbao {
  color: #f9b30d;
}
.icon-dianpu1 {
  color: #f5643d;
}
.icon-tianchongxing- {
  color: #45b9bc;
}
.icon-tuijianren {
  color: #45b9bc;
}
.icon-gerenziliao {
  color: #f9b30d;
}
.van-cell__title {
  margin-left: 0.5rem;
}
.technician_status {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0 0.5rem;
}
.technicial_status_bg {
  background-color: #d2d2d2;
}
.col_F5643D {
  color: #f5643d;
}
.iconfont {
  font-size: 0.9rem;
}
.van-popup {
  width: 75%;
}
.wks_label {
  font-size: 0.75rem;
  padding: 1rem 1.25rem;
}
.wks_icon {
  width: 50%;
  float: left;
  text-align: center;
  font-size: 0.75rem;
  color: #5c5a5a;
}
.wks_icon span {
  font-size: 3rem;
  color: #d2d2d2;
}
.btn_box {
  text-align: center;
}
.check_btn {
  background-color: #45b9bc;
  color: white;
  padding: 0.4rem 3.5rem;
  font-size: 0.9rem;
  border-radius: 5px;
  margin: 3.25rem 0 1.5rem;
}
.work_status {
  color: #45b9bc !important;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/tech_center.vue